<template>
  <v-dialog v-model="shown" max-width="500">
    <v-card class="pa-2">
      <v-card-title class="headline">{{ $t('common.attention') }}</v-card-title>

      <v-card-text>
        <span
          v-html="
            $t('ai_features.token_assignment_confirmation', {
              organizationName,
              totalTokens: formattedTotalTokens,
            })
          "
          class="body-2 blue-grey--text text--darken-3"
        />

        <HumanizedNumericTextField
          class="mt-2 mb-4"
          :allowDecimals="false"
          :value="totalTokensConfirmed"
          :vuetifyTextFieldProps="{
            class: 'mt-8 mb-4',
            label: $t('ai_features.token_assignment_tokens_label'),
            dense: true,
          }"
          @change="totalTokensConfirmed = $event"
        />

        <span class="body-2 blue-grey--text text--darken-3">
          {{ $t('ai_features.token_assignment_tracking_number_confirmation') }}
        </span>

        <v-text-field
          v-model="trackingNumberConfirmed"
          class="mt-2"
          :label="$t('ai_features.token_assignment_tracking_number_label')"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn plain @click="onCancel">{{ $t('common.button.cancel') }}</v-btn>
        <v-btn
          color="primary"
          plain
          :disabled="!isConfirmed"
          @click="onAddTokens"
          >{{ $t('ai_features.assign_tokens') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import HumanizedNumericTextField from '@/components/UI/HumanizedNumericTextField.vue'

export default {
  name: 'TokenAssignmentConfirmation',

  components: { HumanizedNumericTextField },

  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    organizationName: {
      type: String,
      required: true,
    },
    totalTokensToAssign: {
      type: [Number, String],
      required: true,
    },
    trackingNumber: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      totalTokensConfirmed: '',
      trackingNumberConfirmed: '',
    }
  },

  watch: {
    trackingNumber(newValue) {
      this.trackingNumberConfirmed = newValue
    },
  },

  computed: {
    isConfirmed() {
      return (
        String(this.totalTokensConfirmed) === String(this.totalTokensToAssign)
      )
    },

    formattedTotalTokens() {
      const num = Number(this.totalTokensToAssign)
      if (isNaN(num)) return this.totalTokensToAssign
      return num.toLocaleString(navigator.language)
    },
  },

  methods: {
    onAddTokens() {
      this.$emit(
        'confirm',
        this.totalTokensConfirmed,
        this.trackingNumberConfirmed
      )

      this.totalTokensConfirmed = ''
      this.trackingNumberConfirmed = ''
    },

    onCancel() {
      this.$emit('cancel')
      this.totalTokensConfirmed = ''
      this.trackingNumberConfirmed = ''
    },
  },
}
</script>

<style scoped>
.v-card-text {
  font-size: 16px;
}
</style>
